export const iosAppUrl =
  "https://apps.apple.com/se/app/ecomp/id6739537670?itscg=30200&itsct=apps_box_link&mttnsubad=6739537670";

export const androidAppUrl = "https://play.google.com/store/apps/details?id=com.masystem.DigitalLicenseApp";
